import React from 'react';
export function LoadingState() {
  return <div className="flex flex-col w-full animate-pulse" data-id="element-83">
      {[1, 2, 3, 4, 5].map(i => <div key={i} className="flex items-center justify-between py-4 px-6 border-b border-[#DDDBDA] last:border-0" data-id="element-84">
          <div className="flex items-center space-x-4 flex-1" data-id="element-85">
            <div className="w-8 h-10 bg-gray-200 rounded" data-id="element-86"></div>
            <div className="space-y-2 flex-1 max-w-md" data-id="element-87">
              <div className="h-4 bg-gray-200 rounded w-3/4" data-id="element-88"></div>
              <div className="h-3 bg-gray-200 rounded w-1/2" data-id="element-89"></div>
            </div>
          </div>
          <div className="flex items-center space-x-4" data-id="element-90">
            <div className="h-6 w-20 bg-gray-200 rounded-full" data-id="element-91"></div>
            <div className="h-8 w-16 bg-gray-200 rounded" data-id="element-92"></div>
          </div>
        </div>)}
    </div>;
}